<div class="ws-product-card__placeholder">
  <a class="ws-product-card__placeholder-title"
     [routerLink]="builderLink"
     [queryParams]="builderLinkQueryParams">
    {{cake.name}}
  </a>

  @if (isPriceVisible) {
    <cake-item-price
      class="d-block ws-product-card__placeholder-price"
      [currency]="currency"
      [pieces]="pieces"
      [hasPicture]="false"
      [isDifferentPrices]="cake.minPrice !== cake.maxPrice"
      [perUnitText]="('cakeBuilder.sizeUnits.unitType.' + cake.sizeUnit) | translate"
      [price]="cake.minPrice"
      [discount]="cake.discount?.value"
    ></cake-item-price>
  }
</div>
